export const DEFAULT_REPEATER_FOR_SAVING = 'my_stuff';
